<template>
  <ResponsiveLayout :sticky-actions="true">
    <template #header_end><HeaderHelp /></template>
    <div class="kds-main-wrapper">
      <img
        :src="logosKaiaSword"
        alt="Kaia Health transitioning to Sword Health"
        class="sword-redirect__logos"
      />
      <div class="kds-content-block kds-typography-center">
        <h1 class="kds-typography-display-small">
          {{ $t('us__sword_redirect__title') }}
        </h1>
        <p class="kds-typography-paragraph-large kds-color-text-secondary">
          {{ $t('us__sword_redirect__description') }}
        </p>
      </div>
    </div>
    <template #actions>
      <BaseButton
        :text="$t('us__sword_redirect__cta')"
        @click="handleContinue"
      />
      <p
        class="kds-typography-paragraph-small kds-typography-center kds-color-text-tertiary"
      >
        {{
          $t('us__sword_redirect__redirect_countdown', { seconds: countdown })
        }}
      </p>
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import BaseButton from '@shared/components/BaseButton.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import HeaderHelp from '@us/app/components/HeaderHelp.vue'
import logosKaiaSword from '@us/app/assets/img/sword_redirect.svg'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import useLandingPageStore from '@shared/stores/useLandingPageStore.js'

const SWORD_REDIRECT_URLS_BY_ELIGIBILITY_GROUP = {
  1: 'https://meet.swordhealth.com/thrive/united',
  34: 'https://meet.swordhealth.com/thrive/surest',
  133: 'https://meet.swordhealth.com/thrive/umr',
  232: 'https://meet.swordhealth.com/thrive/surest',
}
const DEFAULT_SWORD_REDIRECT_URL = 'https://meet.swordhealth.com/thrive'

const corporateStore = useCorporateStore()
const landingPageStore = useLandingPageStore()

const redirectUrl = computed(() => {
  const lp = landingPageStore.landingPage
  if (
    lp?.eligibilityVerificationType === 'sword' &&
    lp?.eligibilityVerificationExternalUrl
  ) {
    return lp.eligibilityVerificationExternalUrl
  }
  return (
    SWORD_REDIRECT_URLS_BY_ELIGIBILITY_GROUP[
      corporateStore.corporate?.corporateEligibilityGroupId
    ] ?? DEFAULT_SWORD_REDIRECT_URL
  )
})

const countdown = ref(15)
let countdownInterval = null
let hasRedirected = false

const handleContinue = () => {
  if (hasRedirected) return
  hasRedirected = true
  clearInterval(countdownInterval)
  window.location.assign(redirectUrl.value)
}

onMounted(() => {
  countdownInterval = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(countdownInterval)
      handleContinue()
    }
  }, 1000)
})

onUnmounted(() => {
  clearInterval(countdownInterval)
})
</script>

<style lang="scss" scoped>
.sword-redirect__logos {
  height: 42px;
}
</style>
